const id_whs_itemout = {
    "": "barang keluar",
}

export default id_whs_itemout;